var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{on:{"click":_vm.alterarDados}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Alterar Dados")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }